export default "__VITE_ASSET__DVcxMtPT__"